import { useState } from 'react'
import { useSpeechRecognition } from 'react-speech-kit'
import { IoIosMic, IoIosPause, IoIosMicOff } from 'react-icons/io'
import s from './SpeechToText.scss'

const SpeechToText = ({ setValue, speechRecording }) => {
  const [blocked, setBlocked] = useState(false)

  const onResult = result => {
    setValue(result)
  }

  const onError = event => {
    if (event.error === 'not-allowed') {
      setBlocked(true)
    }
  }

  const onEnd = () => {
    // do something here
  }

  const { listen, listening, stop, supported } = useSpeechRecognition({
    onResult,
    onEnd,
    onError
  })

  speechRecording.stop = stop

  const toggle = supported
    ? listening
      ? stop
      : () => {
          setBlocked(false)
          listen({ interimResults: false })
        }
    : () => false

  return (
    <button className={s.speechBtn} disabled={!supported || blocked} type="button" onClick={toggle}>
      {supported ? listening ? <IoIosPause /> : <IoIosMic /> : <IoIosMicOff />}
    </button>
  )
}

export default SpeechToText
